import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import {
  getAllIndustrylist,
  getBusinessUnit,
} from "../../../service/BusinessUnit/BusinessUnitService";
import { City, Country, State } from "country-state-city";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import SpinnerComponent from "../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const AddBusinessUnit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  //COUNTRY-STATE-CITY
  let countryData = Country.getAllCountries();
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  //-----------------------------------------////

  const [address, setAddress] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [industryList, setAllIndustryList] = useState({});
  const [businessUnitName, setBusinessUnitName] = useState("");
  const [shortName, setShortName] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [accountingKey, setAccountingKey] = useState("");
  const [industryId, setIndustry] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getIndustryDataList();
  }, []);

  async function getIndustryDataList() {
    setIsLoading(true);
    getAllIndustrylist().then(function (result) {
      // console.log(result.data, "datadatadatadatada");
      const response = result.data;
      // console.log(response, "rrrr");
      setAllIndustryList(response.data.industryList);
      setIsLoading(false);
    });
  }

  let industryDropdown = <option>Loading...</option>;
  if (industryList && industryList.length > 0) {
    industryDropdown = industryList.map((industryRow, index) => (
      <option value={industryRow.id}>{industryRow.name}</option>
    ));
  }

  //COUNTRY-STATE-CITY

  const onCountry = (e) => {
    setCountry(e.target.value);
    setStateData(State.getStatesOfCountry(e.target.value));
  };

  const onState = (e) => {
    setState(e.target.value);
    setCityData(City.getCitiesOfState(country, e.target.value));
  };

  const onCity = (e) => {
    setCity(e.target.value);
  };

  //-----------------------///

  const onPinCode = (e) => {
    setPinCode(e.target.value);
  };

  const onAddress = (e) => {
    setAddress(e.target.value);
  };

  const onBusinessUnitName = (e) => {
    setBusinessUnitName(e.target.value);
  };

  const onShortName = (e) => {
    setShortName(e.target.value);
  };

  const onIdentificationNumber = (e) => {
    setIdentificationNumber(e.target.value);
  };

  const onAccountingKey = (e) => {
    setAccountingKey(e.target.value);
  };

  const onIndustry = (e) => {
    setIndustry(e.target.value);
  };

  const onAddNow = () => {
    if (businessUnitName === "") {
      toast.error("Please type operator unit name");
    } else if (shortName === "") {
      toast.error("Please type short name");
    } else if (identificationNumber === "") {
      toast.error("Please type BU identification number");
    } else if (accountingKey === "") {
      toast.error("Please type BU general ledger key");
    } else if (industryId === "") {
      toast.error("Please select industry");
    } else if (country === "") {
      toast.error("Please select country");
    } else if (state === "") {
      toast.error("Please select state");
    } else if (city === "") {
      toast.error("Please select city");
    } else if (pinCode === "") {
      toast.error("Please type zip code");
    } else if (address === "") {
      toast.error("Please type your address");
    } else {
      setIsLoading(true);
      getBusinessUnit(
        businessUnitName,
        shortName,
        identificationNumber,
        accountingKey,
        industryId,
        countryData.find((c) => c.isoCode === country)?.name,
        stateData.find((c) => c.isoCode === state)?.name,
        city,
        pinCode,
        address,
        (r) => {
          // console.log(r, "response");
          if (r.success === true) {
            setIsLoading(false);
            toast.success(r.message);

            navigate("/businessunit");
          } else {
            setIsLoading(false);
            toast.error(r.message);
          }
        }
      );
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain businessUnit">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/businessunit"
            breadcm={`${t("configuration")} > `}
            title={`${t("business_unit")} > ${t("add_business_unit")}`}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase p-4">
            <form>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="businessUnitName">
                    {t("business_unit_name")}
                  </label>
                  <input
                    type="text"
                    id="businessUnitName"
                    className="form-control"
                    placeholder={t("business_unit_name")}
                    name=""
                    onChange={onBusinessUnitName}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="shortname">{t("short_name")}</label>
                  <input
                    type="text"
                    id="shortname"
                    className="form-control"
                    placeholder={t("short_name")}
                    name=""
                    onChange={onShortName}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="buIdentificationname">
                    {t("bu_identification_number")}
                  </label>
                  <input
                    type="text"
                    id="buIdentificationname"
                    className="form-control"
                    placeholder={t("bu_identification_number")}
                    name=""
                    onChange={onIdentificationNumber}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="accountingkey">{t("accounting_key")}</label>
                  <input
                    type="text"
                    id="accountingkey"
                    className="form-control"
                    placeholder={t("accounting_key")}
                    name=""
                    onChange={onAccountingKey}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="Industry">{t("industry")}</label>
                  <select
                    className="form-control"
                    id="Industry"
                    onChange={onIndustry}
                  >
                    <option selected hidden>
                      {t("select_industry")}
                    </option>
                    {industryDropdown}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="Country">{t("country")}</label>
                  <select
                    className="form-control"
                    id="Country"
                    onChange={onCountry}
                  >
                    <option selected hidden>
                      {t("select_country")}
                    </option>
                    {countryData.map((con) => (
                      <option value={con.isoCode}>{con.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label htmlFor="state">{t("state")}</label>
                  <select
                    className="form-control"
                    id="state"
                    onChange={onState}
                  >
                    <option selected hidden>
                      {t("select_state")}
                    </option>
                    {stateData.map((sta) => (
                      <option value={sta.isoCode}>{sta.name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="city">{t("city")}</label>
                  <select className="form-control" id="city" onChange={onCity}>
                    <option selected hidden>
                      {t("select_city")}
                    </option>
                    {cityData.map((cit) => (
                      <option value={cit.name}>{cit.name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="zipcode">{t("zip_code")}</label>
                  <input
                    type="number"
                    id="zipcode"
                    className="form-control"
                    placeholder={t("zip_code")}
                    name=""
                    onChange={onPinCode}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Address">{t("address")}</label>
                  <textarea
                    className="form-control"
                    id="Address"
                    placeholder={t("address")}
                    onChange={onAddress}
                  ></textarea>
                </div>
              </div>
              <button type="button" className="commonButton" onClick={onAddNow}>
                {t("add_now")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBusinessUnit;
